/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PublicEntranceTab from './tabs/PublicEntranceTab';
import BuildingEntranceTab from './tabs/BuildingEntranceTab';
import { useTranslation } from 'react-i18next';

const DoorLockConfig = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('public');
  const [publicEntrances, setPublicEntrances] = useState([]);
  const [buildingEntrances, setBuildingEntrances] = useState([]);

  return (
    <div className="p-6 bg-gradient-to-br from-skin-base to-skin-secondary container-height app-text">
      <div className="flex h-tab">
        <div
          onClick={() => setActiveTab('public')}
          className={`
            cursor-pointer
            relative px-4 py-2
            ${activeTab !== 'public' ? 'text-gray-800 bg-white' : 'text-gray-600 bg-gray-200'}
            border-t border-l border-r border-gray-300
            z-20
          `}
          style={{ borderTopRightRadius: '1rem' }}
        >
          {t('Public Entrance')}
        </div>
        <div
          onClick={() => setActiveTab('building')}
          className={`
            cursor-pointer
            relative px-4 py-2
            ${activeTab !== 'building' ? 'text-gray-800 bg-white' : 'text-gray-600 bg-gray-200'}
            border-t border-l border-r border-gray-300
            z-10
          `}
          style={{ borderTopRightRadius: '1rem' }}
        >
          {t('Building Entrance')}
        </div>
      </div>

      <div className="border border-gray-300 p-4 h-tab-content">
        {activeTab === 'public' ? (
          <PublicEntranceTab />
        ) : (
          <BuildingEntranceTab buildingEntrances={buildingEntrances} />
        )}
      </div>
    </div>
  );
};

export default DoorLockConfig;